import { makeStyles } from '@material-ui/core/styles';
import { COLORS } from '../../../styles/constants';

export const useStyles = makeStyles(theme => ({
	popoverPaper: {
		maxWidth: 650,
		backgroundColor: COLORS.BACKGROUND_GREY_LIGHT,
		boxShadow: theme.shadows[2]
	}
}));
